module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4-old.1e952105.mp3";